<template>
  <div id="NIM">
    <iframe ref="NimIframe" :src="src" width="100%" height="100%" data-accid="@buyer.WyAccId" frameborder="0"></iframe>
  </div>
</template>

<script>
var data = {}
export default {
  name: "NIM",
  props: {},
  data() {
    return {
      src: `${this.$store.getters.CHAT()}&to=@buyer.WyAccId`
    };
  },
  methods: {

  },
  mounted() {
  },
  watch: {

  }
};
</script>

<style scoped>
#NIM {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/contact/nim.vue